import { lazy } from "react";
import Loadable from "components/Loadable.tsx";
import FineReports from "./components/FineReports";

const List = Loadable(lazy(() => import("features/fine/components/List")));

const routes = {
  path: "fine",
  children: [
    { path: "", element: <List /> },
    { path: "reports", element: <FineReports /> },
  ],
};

export default routes;
